import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/message/sysMessageTemplate/list',params);
    },

    edit(params) {
        return common.put('/rocheManage/message/sysMessageTemplate/edit',params);
    },
}



// WEBPACK FOOTER //
// ./src/api/sysmanagement/emailtemplate.js